import { getPriceFormatted } from '@/utils/app/number'

import { ArticleOrder } from '@/types/operations/order'

export const getPrice = (article: ArticleOrder): string => {
    // Not price weight
    if (!article.product.is_price_weight) {
        return getPriceFormatted(article.quantity * article.product.price)
    }

    // Price weight by weight
    if (article.product.is_price_weight) {
        return `~ ${getPriceFormatted(
            article.product.price * (article.quantity / 1_000),
        )}`
    }

    // Price weight by unit
    return getPriceFormatted(
        ((article.product.price * article.product.weight) / 1_000) *
            article.quantity,
    )
}

export const getPriceTotal = (articles: ArticleOrder[]): string => {
    let priceTotal = 0

    for (const article of articles) {
        // Not price weight
        if (!article.product.is_price_weight) {
            priceTotal += article.quantity * article.product.price
        }

        // Price weight by weight
        if (article.is_weight_quantity) {
            priceTotal += article.product.price * (article.quantity / 1_000)
        }

        // Price weight by unit
        if (article.product.is_price_weight && !article.is_weight_quantity) {
            priceTotal +=
                ((article.product.price * article.product.weight) / 1_000) *
                article.quantity
        }
    }

    const somePriceWeight = articles.some(
        (article) => article.product.is_price_weight,
    )

    if (somePriceWeight) {
        return `~ ${getPriceFormatted(priceTotal)}`
    }

    return getPriceFormatted(priceTotal)
}
